export const LINKEDIN_CLICK_ID_PARAM = 'li_fat_id'
export const LINKEDIN_CLICK_ID_COOKIE = 'li_fat_id'
export const SOCIAL_MEDIUM = 'social'
export const PAID_SOCIAL_MEDIUM = 'paid_social'

const LINKEDIN_SOURCES = new Set(['linkedin', 'linkedin.com', 'www.linkedin.com', 'lnkd.in'])

const MAX_CLICK_ID_LENGTH = 256

/** A trimmed click id, or undefined when empty or implausibly long. */
export function parseLinkedInClickId(value?: string | null): string | undefined {
  const trimmed = value?.trim()
  return trimmed && trimmed.length <= MAX_CLICK_ID_LENGTH ? trimmed : undefined
}

function clickIdFromQuery(urlOrSearch?: string): string | undefined {
  if (!urlOrSearch) return undefined
  const query = urlOrSearch.includes('?') ? urlOrSearch.slice(urlOrSearch.indexOf('?') + 1) : urlOrSearch
  return parseLinkedInClickId(new URLSearchParams(query).get(LINKEDIN_CLICK_ID_PARAM))
}

/** The click id from the current URL, else the cookie the landing page stored. */
export function getLinkedInClickId(search: string, cookieValue?: string): string | undefined {
  return clickIdFromQuery(search) ?? parseLinkedInClickId(cookieValue)
}

export interface LinkedInVisit {
  source?: string
  medium?: string
  campaign?: string
  /** Sourcebuster's landing URL for the current visit (`current_add.ep`). */
  entrancePoint?: string
  search?: string
}

export interface LinkedInPaidOverride {
  utm_source__c: string
  utm_medium__c: string
}

/** Paid only when this visit arrived with li_fat_id; an untagged LinkedIn referral stays social. */
export function resolveLinkedInPaid(visit: LinkedInVisit): LinkedInPaidOverride | null {
  const source = visit.source?.toLowerCase() ?? ''
  if (!LINKEDIN_SOURCES.has(source)) return null
  const medium = visit.medium?.toLowerCase() ?? ''
  const arrivedWithClickId = Boolean(clickIdFromQuery(visit.search) ?? clickIdFromQuery(visit.entrancePoint))
  if (medium === SOCIAL_MEDIUM || medium === 'referral') {
    return arrivedWithClickId ? { utm_source__c: 'linkedin', utm_medium__c: PAID_SOCIAL_MEDIUM } : null
  }
  // Cookies written by the old rule stay for 12 months; an uncampaigned paid_social with no click id is organic
  if (medium === PAID_SOCIAL_MEDIUM && (visit.campaign ?? '(none)') === '(none)' && !arrivedWithClickId) {
    return { utm_source__c: 'linkedin', utm_medium__c: SOCIAL_MEDIUM }
  }
  return null
}
